const actionTypeIdentifier = '3C96E8E4-923D-4ADD-9278-28692F612D77';

export const performInvoiceAuditMatch = `PERFORM-INVOICE-AUDIT-MATCH${actionTypeIdentifier}`;
export const performInvoiceAuditMatchError = `PERFORM-INVOICE-AUDIT-MATCH-ERROR${actionTypeIdentifier}`;


